import { useTranslation } from "react-i18next";
import { useDateFnsFormattersWithLocale } from "@tellescope/react-hooks";
import { WaitingRoomView } from "@tellescope/video-calling";
import { useVideoWaitingRoom, type VideoWaitingRoomInRoomStatus } from "./useVideoWaitingRoom";
import { VideoCallTerminalNotice } from "./VideoCallTerminalNotice";

interface VideoWaitingRoomProps {
  calendarEventId: string;
  /** Set while the enduser is connected to the room but the provider isn't in it */
  inRoomStatus?: VideoWaitingRoomInRoomStatus;
}

export const VideoWaitingRoom = ({ calendarEventId, inRoomStatus }: VideoWaitingRoomProps) => {
  const { t } = useTranslation("videoCalling");
  const { format } = useDateFnsFormattersWithLocale();
  const { status, scheduledStartTimeInMS } = useVideoWaitingRoom(calendarEventId, inRoomStatus);

  if (status === "ended" || status === "cancelled" || status === "unavailable") {
    return <VideoCallTerminalNotice reason={status} />;
  }

  return (
    <div className="flex-1 flex flex-col items-center justify-center overflow-y-auto">
      <div className="w-full max-w-md">
        {scheduledStartTimeInMS !== undefined && (
          <p className="px-4 pt-4 text-sm text-center text-muted-foreground">
            {t("Your appointment is scheduled for {{dateTime}}", {
              dateTime: format(new Date(scheduledStartTimeInMS), "PPPPp"),
            })}
          </p>
        )}
        <WaitingRoomView userRole="enduser" waitingStatus={status} />
      </div>
    </div>
  );
};
